import App from './App.svelte';
import CityLocalizer from "./util/cityLocalizer";
import {pages} from './database/pages.js';
import {services} from './database/services.js';
import {people} from './database/people.js';

window.cityLocalizer = CityLocalizer;
window.pages = pages;
window.services = services;
window.people = people;

const app = new App({
	target: document.body,
	hydrate: true,
	props: {
		ready: false
	}
});

window.initMap = function ready() {
	app.$set({ready: true});
}

export default app;